import { useTranslation } from 'react-i18next';

import { Container, ErrorState, Header } from '~/components';

export const ErrorBoundary = () => {
  const { t } = useTranslation(['forum']);

  return (
    <>
      <Header.Root>
        <Header.Content title={t('forum:overview.header.title')} />
      </Header.Root>

      <Container>
        <ErrorState onRetry={() => window.location.reload()} title={t('forum:overview.error.title')} />
      </Container>
    </>
  );
};
